import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";
import { primaryColor, backgroundBrandSecondary, textNeutralTertiary, white, backgroundNeutralSecondary } from "../../../core/theme";

export const style: { [key: string]: SxProps<Theme> } = {
    dialog: {
        minWidth: "40%",
    },
    dialogTitle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .message-icon": {
            color: primaryColor,
            marginRight: "12px",
        },
    },
    name: {
        backgroundColor: backgroundBrandSecondary,
        padding: "16px",
        color: textNeutralTertiary,
        marginBottom: "12px",
        "& span": {
            color: "#000",
            fontWeight: "700",
        },
    },
    systemComment: {
        display: "flex",
        color: textNeutralTertiary,
        "& span": {
            color: "#000",
            fontWeight: "700",
        },
        "& svg": {
            color: "#000",
            marginRight: "12px",
        },
        marginBottom: "16px",
    },
    manualComment: {
        display: "flex",
        flexDirection: "column",
        "& div:first-of-type": {
            display: "flex",
        },
        "& .comment-reated-at": {
            color: textNeutralTertiary,
        },
        "& .creator-name": {
            fontWeight: "700",
            color: "#000",
        },
        marginBottom: "16px",
    },
    createdAt: {
        fontSize: "12px",
        maxWidth: "max-content",
    },
    avatar: {
        backgroundColor: primaryColor,
        color: white,
        height: "28px",
        width: "28px",
        fontSize: "12px",
        marginRight: "12px",
    },
    commentContent: {
        backgroundColor: backgroundNeutralSecondary,
        padding: "8px",
        marginTop: "8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    commentform: {
        display: "flex",
        justifyContent: "space-between",
        "& textarea": {
            maxWidth: "75%",
        },
    },
};